<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { ArrowRightIcon } from 'lucide-vue-next';
import type { Product } from '@/types/product';
import Button from '../ui/button/Button.vue';
import Card from './Card.vue';
import { route } from '@/route';

interface Props {
  title?: string;
  description?: string;
  products?: Product[];
  viewAllLink?: string;
}

withDefaults(defineProps<Props>(), {
  title: 'Хиты продаж',
  description: 'Проверенные временем и тысячами пользователей инструменты, которые сделают ваш сад идеальным.',
  products: () => [],
  viewAllLink: route('catalog.list'),
});
</script>

<template>
  <section id="product-hits" class="bg-white py-12">
    <div class="mx-auto max-w-7xl px-4 md:px-6">
      <div class="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <div class="max-w-2xl">
          <h2 class="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            {{ title }}
          </h2>
          <p class="mt-2 text-muted-foreground">
            {{ description }}
          </p>
        </div>

        <Button variant="outline" as-child class="w-fit">
          <Link :href="viewAllLink" class="inline-flex items-center gap-1">
            Смотреть все
            <ArrowRightIcon class="size-4" />
          </Link>
        </Button>
      </div>

      <div v-show="products.length > 0" class="grid grid-cols-1 gap-6 md:grid-cols-4">
        <Card v-for="product in products" :key="`hit-section-${product.id}`" :product="product" />
      </div>
    </div>
  </section>
</template>
